import { module } from 'modujs';
import gsap from "gsap";

export default class extends module {
    constructor(m) {
        super(m);

        this.intro = this.el.querySelector('.home-video_intro');

        this.tlText = gsap.timeline({ paused: true });
        setTimeout(() => {
            this.tlText.fromTo(
                this.intro.querySelectorAll('.char'),
                { opacity: 0.1 },
                { opacity: 1, duration: 0.5, ease: 'none', stagger: 0.03 },
            );
        }, 500);

        window.addEventListener('homeVideoIntroProgress', (e) => {
            const { target, progress } = e.detail;
            if (this.tlText) {
                this.tlText.progress(progress);
            }
        });
        
    }

    toggleVideo(e) {
        if (e.way == 'enter') {
            e.target.play();
        } else {
            e.target.pause();
        }
    }
}
